module.exports = __webpack_public_path__ + "static/media/main-logo1.31af3bd2.png";